import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import InvoicesEditor from "../invoices-editor";

const CreateInvoice = () => {
  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Neue Rechnung erstellen</PageTitle>
        </div>
      </PageTitleContainer>
      <div className="p-4 w-1/2 items-center m-auto">
        <InvoicesEditor type="create" />
      </div>
    </div>
  );
};

export default CreateInvoice;
